module.exports = {"460322451":"永暑岛"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460322.json
// module id = 2017
// module chunks = 0